import { useHelmet } from "../hooks/use-helmet";

/**
 * Minimal per-route SEO manager (no react-helmet dependency to avoid churn).
 * Injects <title>, meta description, canonical, OG title/description, and
 * arbitrary application/ld+json blocks in <head>.
 */
export default function SEO({ title, description, canonical, image, jsonLd }) {
  useHelmet({ title, description, canonical, image, jsonLd });
  return null;
}
